import { render, staticRenderFns } from "./ManageTagsModal.vue?vue&type=template&id=4a6034da&scoped=true"
import script from "./ManageTagsModal.vue?vue&type=script&lang=js"
export * from "./ManageTagsModal.vue?vue&type=script&lang=js"
import style0 from "./ManageTagsModal.vue?vue&type=style&index=0&id=4a6034da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6034da",
  null
  
)

export default component.exports